console.log('js/popover.js -> v0.1.0');

//popover
$(function() {
	if ( $('[data-toggle="popover"]').length ) {
		$('*[data-toggle="popover"]').hover( function() {
		  	$(this).parent().find('.popover').toggle();
		  	return false;
		});
	}
});
